(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["baby-bat--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balanced--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["balanced-el--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fungo--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fungo-bundle--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product--faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natural--product-faq-new"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natural--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["natural-bundle--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["youth-bundle--product-faq"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();
})();
